export const environment = {
  production: false,
  authTokenKey: 'storeLTGOSession',
  authTokenKeyCdi: 'storeCDISession',
  api: 'api',
  tema: 'tema',
  apiUrlLtgo: "https://api.littletreesgo.com/api/v1",
  apiUrlCdi: "https://api.casadoimportadogo.com/api/v1"
};
